 class WishlistBtn extends HTMLElement {
    constructor() {
      super();
      this.LOCAL_STORAGE_KEY = 'shopify-wishlist';
      this.DELIMITER = ',';
      this.BUTTON_ACTIVE_CLASS = 'active';
      this.button = null;
    }

    connectedCallback() {
      this.button = this.querySelector('[button-wishlist]');
      if (!this.button) {
        console.warn('[wishlist-btn] Missing [button-wishlist] inside the component.');
        return;
      }

      this.handle = this.button.getAttribute('data-product-handle');
      if (!this.handle) {
        console.warn('[wishlist-btn] Missing data-product-handle on the button.');
        return;
      }

      this.updateState();
      this.button.addEventListener('click', this.toggleWishlist.bind(this));
      document.addEventListener('shopify-wishlist:updated', this.updateState.bind(this));
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.toggleWishlist);
      }
      document.removeEventListener('shopify-wishlist:updated', this.updateState);
    }

    getWishlist() {
      const list = localStorage.getItem(this.LOCAL_STORAGE_KEY);
      return list ? list.split(this.DELIMITER) : [];
    }

    setWishlist(list) {
      const stringified = list.join(this.DELIMITER);
      if (list.length) {
        localStorage.setItem(this.LOCAL_STORAGE_KEY, stringified);
      } else {
        localStorage.removeItem(this.LOCAL_STORAGE_KEY);
      }

      document.dispatchEvent(new CustomEvent('shopify-wishlist:updated', {
        detail: { wishlist: list }
      }));
    }

    toggleWishlist() {
      const list = this.getWishlist();
      const index = list.indexOf(this.handle);

      if (index === -1) {
        list.push(this.handle);
      } else {
        list.splice(index, 1);
      }

      this.setWishlist(list);
      this.updateState();
      
    }

    updateState() {
      const list = this.getWishlist();
    //  set header icons 
        const icon = document.querySelector(".wishlist-icon");

        if (list) {
          icon?.classList.add("wishlist-icon-active");
        } else if (
          !list && icon?.classList.contains("wishlist-icon-active")) {
          icon.classList.remove("wishlist-icon-active");
        }

      if (list.includes(this.handle)) {
        this.classList.add(this.BUTTON_ACTIVE_CLASS);
      } else {
        this.classList.remove(this.BUTTON_ACTIVE_CLASS);
      }

      // Also reflect visually on the button if needed
      if (this.button) {
        if (list.includes(this.handle)) {
          this.button.classList.add(this.BUTTON_ACTIVE_CLASS);
        } else {
          this.button.classList.remove(this.BUTTON_ACTIVE_CLASS);
        }
      }
    }
  }

  customElements.define('wishlist-btn', WishlistBtn);